import { props as pupProps } from '../EditPupContainer/constants';
import { props as planProps } from '../RecommendNewPlanContainer/constants';

export const props = {
  pup: pupProps,
  plan: planProps,
};
